<template>
  <div>

    <div :id="'row' + booking_id">
      <md-switch :id="'approval' + booking_id" name="approval" class="md-primary" :value="isbookingactive == 1"
        @change="toggleStatus(prbr_id, prbr_is_active, booking_id, isbookingactive, request_type)">
        <h6>
          <br />
          <b-badge style="margin-left: -45px">
            {{ isbookingactive == 1 ? "Active" : "In-Active" }}
          </b-badge>
        </h6>
      </md-switch>
      <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
    </div>

  </div>
</template>

<script>
import NodeLockPannelService from "../../services/NodeLockPannelService";
export default {
  data() {
    return {
      alert: {
        content: "",
        ok: "OK",
      },

      isLoading: false,
    };
  },
  props: {
    brf_no: String,
    booking_no: String,
    table_name: Number,
    item_id: Number,
    is_active: Number,
    prbr_is_active: Number,
    request_type: String
  },
  methods: {

    async toggleStatus(prbr_id, prbr_is_active, booking_id, isbookingactive, request_type) {
      this.isLoading = true;
      console.log("toggleStatus", prbr_id, prbr_is_active, booking_id, isbookingactive, request_type);
      const payload = {
        prbr_id,
        prbr_is_active,
        booking_id,
        isbookingactive,
        request_type,
      };

      try {
        NodeLockPannelService.updateBRFBookingStatus(payload)
          .then((response) => {
            const { data, status, statusText } = response;

            if (status == 200 && data) {
              this.alert.content = data.MSG;
              this.$refs["addPop"].open();
              this.$emit("success"); // Notify parent to refresh data
            }
            this.isLoading = false;
          })
          .catch((error) => {
            this.isSubmited = false;
            console.log("Catch on updateBRFBookingStatus Error: ", error);
          });

      } catch (error) {
        console.error("Error updating updateBRFBookingStatus:", error);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// ToggleSwitch.vue?2fffb090